import type { FaireProductEntity } from "../../entity_types/product";

export const p_wpxw5y4mk6: FaireProductEntity = {
  token: "p_wpxw5y4mk6",
  type: "product",
  name: "Tarot Card Necklace- Lovers 14K Gold stainless steel",
  brandToken: "b_sf3pyfue5x",
  brandName: "HoopLa",
  imageUrl:
    "https://cdn.faire.com/fastly/e15bf1ce8143410f0b66f4fd4d017185f133af055fec6cd5129c62af14211715.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/708f2dc94b5e21699336519cc61263b584a82e2d89d8ee0fdaeadfa899299be9.jpeg",
    "https://cdn.faire.com/fastly/9c20a4237995ce0612e8dc7602e778e80b8a1c2a8cb6f94dd13f74410d9d1b74.jpeg",
    "https://cdn.faire.com/fastly/eeac2ea69346325270881a05e66636acfe5200812a6e2c81bcfa2da8cfca458a.jpeg",
    "https://cdn.faire.com/fastly/a7a9ce57d03751a9321c07654fff1faec41e7c0042caf4f08f2690ae36817893.jpeg",
  ],
  priceDollars: 19.18,
  description:
    "Tarot Card Collection. 18K Gold hand Engraved and enamelled. Each is different and one of a kind based on enamel. Enamel is Forcaté style French enamel made with real gold. The new Tarot cards are a customer favourite with two additions the Lovers. Same great quality. Steel. Steel chain. Genuine Crystals Lobster claw closures. Each crystal is hand placed. \nEnamel is done in a French style using gold for a high quality sheen. These are carefully crafted. \nThe backs are drilled out under the stone for light to penetrate\nand the celestial code of the card lays over your heart",
  tags: [],
  msrpDollars: 38.35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:52.600Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
